import React from "react";
import styles from "./SettingPage.module.css";
import { useEffect } from "react";
import { setHeader } from "../../reduxSlices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import InfoSquare from "../../assets/images/InfoSquare.svg";
import { ReactComponent as UserIcon } from "../../assets/images/User.svg";
import { ReactComponent as EnvironmentIcon } from "../../assets/images/EnvironmentIcon.svg";
import { ReactComponent as PackageIcon } from "../../assets/images/PackageIcon.svg";
import { ReactComponent as TranslationIcon } from "../../assets/images/TranslationIcon.svg";
import { ReactComponent as RightArrow } from "../../assets/images/ArrowRight.svg";
import { Link } from "react-router-dom";
import { VF_ADMIN_ROLE_ID } from "../../constants/constant";

const SettingPage = () => {
  const dispatch = useDispatch();

  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVFAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "settings",
        title: "Configurations",
        subTitle:
          "Here are all of the configurations you can make based on your access",
      })
    );
    localStorage.setItem(
      "selectedOrg",
      JSON.stringify({
        organizationId: "",
        organizationName: "",
      })
    );
  }, []);

  const settingData = isVFAdmin
    ? [
        {
          leftIcon: <UserIcon />,
          title: "Manage Visualise Users",
          subTitle: "Create and manage visualise fundraising users.",
          rightIcon: <RightArrow />,
          navigate: "/vfusers",
        },
        {
          leftIcon: <EnvironmentIcon />,
          title: "Manage Environments",
          subTitle: "Create and manage blackbaud environments.",
          rightIcon: <RightArrow />,
          navigate: "/environments",
        },
        {
          leftIcon: <PackageIcon />,
          title: "Configure Packages",
          subTitle:
            "Create and manage default packages. You can also create custom packages as per organisation’s requirements.",
          rightIcon: <RightArrow />,
          navigate: "/packages",
        },
        {
          leftIcon: <TranslationIcon />,
          title: "Configure Translations",
          subTitle:
            "Manage default organisation's data translation settings. You can select default translation settings while creating any organisation.",
          rightIcon: <RightArrow />,
          navigate: "/configure-translations",
        },
      ]
    : [
        {
          leftIcon: <EnvironmentIcon />,
          title: "Manage Environments",
          subTitle: "Create and manage blackbaud environments.",
          rightIcon: <RightArrow />,
          navigate: "/environments",
        },
        // {
        //   leftIcon: <TranslationIcon />,
        //   title: "Set Targets and Expenses",
        //   subTitle:
        //     "Set targets and record expenses for your fundraising programs.",
        //   rightIcon: <RightArrow />,
        //   navigate: "/expense-target",
        // },
        {
          leftIcon: <TranslationIcon />,
          title: "Configure Translations",
          subTitle: "Manage your organisation's data translation settings.",
          rightIcon: <RightArrow />,
          navigate: "/configure-translations",
        },
      ];

  return (
    <>
      {settingData?.map((item, i) => (
        <Link to={item.navigate} style={{ textDecoration: "none" }} key={i}>
          <div className={styles.rectangleDiv}>
            <div className={styles.leftIcon}>{item.leftIcon}</div>
            <div className={styles.yourOrganisationHasContainer}>
              <p>{item.title}</p>
              <p
                style={{ fontSize: "14px", fontWeight: 500, color: "#8a8a8a" }}
              >
                {item.subTitle}
              </p>
            </div>
            <div className={styles.rightIcon}>{item.rightIcon}</div>
          </div>
        </Link>
      ))}
    </>
  );
};

export default SettingPage;
